import { GetApiCall, PutApiCall } from "./axiosSetup";

export const GET_ACTIVE_MESSAGES = "/message/get-active-messages";
export const GET_MESSAGE_BODY = "/message/get-active-messages"; 
export const UPDATE_MESSAGE_STATUS = "/message/update-message-status";

export const getActiveMessages = async (username) => { return GetApiCall(GET_ACTIVE_MESSAGES, undefined, { username });};
export const getMessageBody = async (messageId) =>GetApiCall(`${GET_MESSAGE_BODY}/${messageId}`);
export const updateMessageStatus = async (messageId, status, username) => {return PutApiCall(`${UPDATE_MESSAGE_STATUS}/${messageId}?username=${username}`, { status,});};